import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import { observer } from 'mobx-react';

import { Label } from 'core/components/label';
import { useStore } from 'core/store/store.mobx';
import alertIcon from 'core/assets/svg/triangle-alert.svg';

import useStyles from './matching-active-policy-warning.styles';

// #35249: a matching active policy no longer hard-blocks a bind. A named insured can legitimately
// hold several policies (Home, Farm, Rental at different locations), so we warn and let the agent
// proceed intentionally — or catch a genuine duplicate — before finalizing. The same warning runs
// before a purchase link is sent (#34591), where confirming sends the link instead.
const MatchingActivePolicyWarning = observer(() => {
  const localClasses = useStyles();
  const { offer: store } = useStore();
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);

  const shareWarning = store.activePolicyShareWarning;
  const action = shareWarning ? `share the ${shareWarning.linkName}` : 'purchase this one';

  const onConfirm = async () => {
    if (shareWarning) {
      store.confirmActivePolicyShare();
      return;
    }
    setSubmitting(true);
    const { id, systemId } = await store.confirmMatchingActivePolicyBind();
    setSubmitting(false);
    if (id && systemId) {
      history.push(`/offer/${store.offer.id}/purchased`);
    }
  };

  const onCancel = () => {
    store.cancelMatchingActivePolicyWarning();
  };

  return (
    <>
      <img src={alertIcon} alt="" className={localClasses.alertIcon} />
      <Label type="greenBig" className={localClasses.title}>
        This member already has an active policy
      </Label>
      <Label type="infoValue" className={localClasses.body}>
        {'An active policy already exists for this named insured at this property. A member can hold more than one ' +
          `policy, so this may be intentional. Confirm you want to ${action} anyway, or cancel to review.`}
      </Label>
      <Grid container justifyContent="flex-end" className={localClasses.buttons}>
        <Button
          onClick={onCancel}
          variant="contained"
          color="secondary"
          className={localClasses.button}
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          className={localClasses.button}
          disabled={submitting}
        >
          {shareWarning ? 'Share anyway' : 'Purchase anyway'}
        </Button>
      </Grid>
    </>
  );
});

export default MatchingActivePolicyWarning;
